export default __webpack_public_path__ + "static/media/gced_details.ecbf80bb.png";